export const faqEntries: ReadonlyArray<[question: string, answer: string]> = [
  [
    "De onde vêm os dados?",
    "De fontes públicas e oficiais, incluindo Justiça/CITIUS, Publicações MJ, AT, Segurança Social, ASAE e Livro de Reclamações (quando existe estatística pública).",
  ],
  [
    "Posso pesquisar por matrícula ou VIN?",
    "Ainda não. Nesta versão, a análise é ao stand/empresa apenas por NIF/NIPC completo. Matrícula/VIN exige integrações específicas e ficará para versões futuras.",
  ],
  [
    "Isto substitui aconselhamento jurídico?",
    "Não. O relatório organiza sinais públicos para ajudar na decisão. Em casos de risco elevado, deve validar com apoio jurídico.",
  ],
  [
    "Como desbloqueio o relatório?",
    "Depois da prévia gratuita, paga uma única vez em Stripe Checkout. Em Portugal, o fluxo está preparado para cartão, MB WAY e Multibanco.",
  ],
];
